import { reducedStream, reducer } from '@ardoq/rxbeach';
import {
  dashboardFilterDatePickerToggled,
  dashboardFilterPillInputValueChanged,
  dashboardFilterPillOperatorPopoverToggled,
  dashboardFilterPillValuePopoverToggled,
} from 'dashboard/DashboardBuilder/streams/actions';
import {
  DashboardFilterPillUIState,
  getInitialDashboardFilterPillUIState,
} from '@ardoq/table-filter-bar';

// key here is dashboardFilterId
export type DashboardFilterPillsUI$State = Record<
  string,
  DashboardFilterPillUIState
>;

const getPopoverToggleReducer =
  (
    popoverAttribute:
      | 'isValuePopoverOpen'
      | 'isOperatorPopoverOpen'
      | 'showDatePicker'
  ) =>
  (
    state: DashboardFilterPillsUI$State,
    {
      dashboardFilterId,
      isOpen,
    }: {
      dashboardFilterId: string;
      isOpen: boolean;
    }
  ) => {
    const pillState =
      state[dashboardFilterId] ?? getInitialDashboardFilterPillUIState();
    return {
      ...state,
      [dashboardFilterId]: {
        ...pillState,
        [popoverAttribute]: isOpen,
      },
    };
  };

const setPopoverInputValue = (
  state: DashboardFilterPillsUI$State,
  {
    dashboardFilterId,
    inputValue,
  }: {
    dashboardFilterId: string;
    inputValue: string | number | null;
  }
) => {
  const pillState =
    state[dashboardFilterId] ?? getInitialDashboardFilterPillUIState();
  return {
    ...state,
    [dashboardFilterId]: {
      ...pillState,
      popoverInputValue: inputValue,
    },
  };
};

export const dashboardFilterPillsUI$ =
  reducedStream<DashboardFilterPillsUI$State>('dashboardFilterPillsUI$', {}, [
    reducer(
      dashboardFilterPillValuePopoverToggled,
      getPopoverToggleReducer('isValuePopoverOpen')
    ),
    reducer(
      dashboardFilterPillOperatorPopoverToggled,
      getPopoverToggleReducer('isOperatorPopoverOpen')
    ),
    reducer(
      dashboardFilterDatePickerToggled,
      getPopoverToggleReducer('showDatePicker')
    ),
    reducer(dashboardFilterPillInputValueChanged, setPopoverInputValue),
  ]);
